<template>
    <SidebarGroup>
        <SidebarGroupLabel v-if="sidebarOpen" class="ml-2 text-muted-foreground">PAGES</SidebarGroupLabel>
        <SidebarMenu>
            <template v-for="item in items">
                <SidebarMenuItem
                    v-if="hasPermission(item)"
                    :key="item.title"
                    :default-open="item.isActive"
                    class="mx-1 rounded hover:bg-cinder-800"
                    :class="isActive(item.url) ? 'bg-cinder-800' : ''"
                    as-child
                    @click="handleSidebarItemClick"
                >
                    <router-link v-slot="{ href, navigate }" :to="{ name: item.url }">
                        <Tooltip
                            :tooltip-trigger-class="'transition duration-200'"
                            :class="'px-1 py-1'"
                            :placement="'right'"
                            :show-tooltip="!isSmallScreen && !sidebarOpen"
                        >
                             <template #trigger>
                                <SidebarMenuButton :tooltip="item.title" :href="href" class="w-full" @click="navigate">
                                    <div class="relative flex-shrink-0">
                                        <AppIcon
                                            v-if="item.icon"
                                            :name="item.icon"
                                            class="h-6 min-h-6 w-6 min-w-6"
                                        />
                                    </div>

                                    <span v-if="sidebarOpen" class="flex w-full items-center justify-between px-2">
                                        <span class="text-sm font-medium">{{ item.title }}</span>
                                    </span>
                                </SidebarMenuButton>
                            </template>
                            {{ item.title }}
                        </Tooltip>
                    </router-link>
                </SidebarMenuItem>
            </template>
        </SidebarMenu>
    </SidebarGroup>
</template>

<script setup>
import AppIcon from '@/components/AppIcon.vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { defineEmits } from 'vue'
import { nextTick } from 'vue'
import Tooltip from '@/components/Tooltip.vue'
import { useIsSmallScreen } from './isSmallScreen.composable'

import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from '@/components/ui/sidebar'
import { screenSize } from '@/utils/Utils'

const props = defineProps({
    items: Array,
    sidebarOpen: Boolean,
})

const emit = defineEmits(['close-sidebar'])
const store = useStore()

const route = useRoute()
const checkPermission = store.getters.checkPermission

function hasPermission(item) {
    if (Array.isArray(item.permissions)) {
        return item.permissions.every((permission) => checkPermission(permission))
    }

    return !item.permission || checkPermission(item.permission)
}

function isActive(to) {
    return route.name === to
}

const { isSmallScreen } = useIsSmallScreen()

function handleSidebarItemClick() {
    nextTick(() => {
        if (screenSize.isLessThan('md')) {
            emit('close-sidebar')
        }
    })
}
</script>
